module.exports = __webpack_public_path__ + "img/lumiflex-logo.7f7cc0fc.svg";